export default (state) => {
    return state.ui.isLoading;
};
